import React, {useState} from 'react';
import PurchaseBox from './PurchaseBox';
import PurchaseBoxTron from './PurchaseBoxTron';
import VipTimer from './VipTimer';
import VipTimerTron from './VipTimerTron';
import Header from '../common/Header'
import { useWallet } from '../WalletProvider';


function Vip() {
    const { currencyDetails } = useWallet();
    const [showTimer, setShowTimer] = useState(true);
    const [errMsg, setErrMsg] = useState(true)

    const handleShowTimer = (value) => {
        setShowTimer(value)
    } 

    const handleErrMsg = (value) => {
        setErrMsg(value)
    } 
    
    return (
        <>
        <Header />
            <section className="section2" id="" data-section="section1">
                {currencyDetails.networkType === "TRON" && currencyDetails.networkType === undefined ? 
                    <VipTimerTron showTimer={showTimer} handleShowTimer={handleShowTimer} />
                    :<VipTimer showTimer={showTimer} handleShowTimer={handleShowTimer} />}
                <div className="container">
                    <div className="caption">
                        <div className="btm-form" style={{ padding: "50px 15px 50px" }}>
                            <div className="pb-5">
                                <div className="col-md-11 m-auto">
                                    {errMsg && <p className='errorMsg'>Please Connect to the wallet first</p>}
                                    <h1 className="mb-5 mem-head"><b>Our VIP Memberships</b></h1>
                                    <div className="fourfour">
                                        {currencyDetails.networkType === "TRON" ? 
                                        <div className="row">
                                             <PurchaseBoxTron duration={1} handleErrMsg={handleErrMsg} handleShowTimer= {handleShowTimer}/>
                                            <PurchaseBoxTron duration={7} handleErrMsg={handleErrMsg}  handleShowTimer= {handleShowTimer} />
                                            <PurchaseBoxTron duration={31} handleErrMsg={handleErrMsg} handleShowTimer= {handleShowTimer} />
                                            <PurchaseBoxTron duration={365} handleErrMsg={handleErrMsg} handleShowTimer= {handleShowTimer} /> 
                                        </div>
                                        :
                                        <div className="row">
                                            <PurchaseBox duration={1} handleShowTimer= {handleShowTimer} handleErrMsg={handleErrMsg} />
                                            <PurchaseBox duration={7}  handleShowTimer= {handleShowTimer} handleErrMsg={handleErrMsg} />
                                            <PurchaseBox duration={31} handleShowTimer= {handleShowTimer} handleErrMsg={handleErrMsg} />
                                            <PurchaseBox duration={365} handleShowTimer= {handleShowTimer} handleErrMsg={handleErrMsg} />
                                        </div>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-11 m-auto">
                                <h3 className="mt-4">Perks of VIP Membership</h3> <p>As a VIP member you will not be charged any service fees. With our prices for memberships, you can rest assured that you will be saving a ton of your hard earned crypto because we offer the best deal available on the market. Also, as a member you will receive priority support via <a href="https://t.me/joinchat/1bh78Y3ejRpkNTg8" target="_blank" rel="noreferrer">Telegram</a>, live chat or email.</p> <h4 className="mt-4">Why choose us?</h4> <p>Well, other than the fact that we offer the best prices, we also have a lot of experience in crypto airdrops. In fact, we have been around since 2018 under the name of Dapple Airdrops, one of the very first MultiTokendrop in the crypto world. </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Vip